<img
  [src]="image"
  [class.boreder-bottom-16]="roundedBottom"
  class="img-fluid"
  [alt]="title"
/>
